import InnerNavBar from "../../components/InnerNavbar/InnerNavbar";
import Footer from "../../components/Footer/Footer";
import { useTranslation } from "react-i18next";
import JobsectionsComponent from "../../components/jobsections/Jobsections";
import { Helmet } from "react-helmet";
const JobPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>
      <section className="job-page">
        <div className="job-page-hedear">
          <InnerNavBar isTransparent={true} />

          <div className="job-header">
            <p>{t("JobsSubtitle")} </p>
          </div>

        </div>
        <div className="job-page-container">
          <JobsectionsComponent />
        </div>
      </section>
      <Footer />
    </>
  );
};

export default JobPage;
